import React,{useState,useEffect}  from 'react'
import {Box,Typography,Container,Grid,Paper,Button, Divider} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowIcon from '@mui/icons-material/ArrowBackRounded';
import CircularProgress from '@mui/material/CircularProgress';
import {IconButton} from "@mui/material"
import {useNavigate} from 'react-router-dom'
import { add_test} from "../Redux/testSlice";
import { add_tests} from "../Redux/testsSlice";
import Header from '../Components/Header'
import CustomDialog from '../Components/CustomDialog'
import useMediaQuery from '@mui/material/useMediaQuery'; 
import UserInput from '../Components/UserInput'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import GridViewContainer from '../Components/GridViewContainer';
import AutoInput from '../Components/AutoInput';
import MultiInput from '../Components/MultiInput';
import edit_test from '../Redux/reducers/edit_test';
import { add_activities,add_activity } from '../Redux/settingSlice';
import dayjs from 'dayjs';
import TimeInput from '../Components/TimeInput';
import DateInput from '../Components/DateInput';
import { MicRounded,FormatAlignCenter, ArrowBack, Edit } from '@mui/icons-material';
import EditorText from '../Components/EditorText';
import generate_test from '../Redux/reducers/generate_test';
import EditTestDialog from '../Components/EditTestDialog';
import NoticeDialog from '../Components/NoticeDialog';
import ItemView from '../Components/ItemView';

const QuestionBox = styled(Box, {
})(({ theme}) => ({
	transition: theme.transitions.create('width', {
	easing: theme.transitions.easing.sharp,
	duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 7,
    backgroundColor: '#100101'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 5
  },
minHeight:300,
maxHeight:450
})
);

const ContainerBox = styled(Box, {
})(({ theme}) => ({
	transition: theme.transitions.create('width', {
	easing: theme.transitions.easing.sharp,
	duration: theme.transitions.duration.enteringScreen,
	}),
	overflowY: 'hidden',
	overflowX: 'hidden'
	})
);
const EditTest = ()=>{

	const response_types= ["selection or True & False","Selection(multiple choices)","True & False"]
	const levels = ["Beginner","Intermediate","Advanced","Expert"]
	const modeArray = ["Strict","Open"]
	const languages = ["French","English","Latino","Arabic","Bengali","Chinese","Spanish","German","Korean","Dutch","Hindi","Swahili","Japanese","Hebrew","Turkish","Portuguese","Russian"]

	const theme = useTheme()
	const test = useSelector(state => state?.test.test);
	const [name,setName] = useState(test?.name)
	const [email,setEmail] = useState("")
	const [description, setDescription] = useState(test?.description);
	const [describe, setDescribe] = useState(test?.describe);
	const [questions, setQuestions] = useState(test?.questions);
	const [duration, setDuration] = useState(null);
	const [start_date, setStart_date] = useState(test?.start_date);
	const [start_moment, setStart_moment] = useState(null);
	const [level, setLevel] = useState(test?.level);
	const navigate = useNavigate()
	const [lang, setLang] = useState(test?.language);
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [response_type, setResponse_type] = React.useState("Selection(multiple choices)");
	const [isInfo, setIsInfo] = React.useState(true);
	const [isPart, setIsPart] = React.useState(false);
	const [isSend, setIsSend] = React.useState(test?.isRealTime ? false : true);
	const [showDialog, setShowDialog] = React.useState(false);
	const [isNext, setIsNext] = React.useState(false);
	const [message, setMessage] = React.useState("");
	const [specialty, setSpecialty] = React.useState(test?.specialty);
	const [field, setField] = React.useState(test?.field);
	const [first_name, setFirst_name] = React.useState("");
	const [last_name, setLast_name] = React.useState("");
	const [participants, setParticipants] = React.useState(test?.users);
	const user = useSelector(state => state?.auth.user);
	const tests = useSelector(state => state?.tests.tests);
	const [trans, setTrans] = React.useState(false);
	const [isGenerated, setIsGenerated] = React.useState(test?.isRealTime ? false : true)
	const [testQuestions, setTestQuestions] = React.useState(test?.testQuestions);
	const [testParams, setTestParams] = React.useState(test);
	const [generating, setGenerating] = React.useState(false);
	const [showEdit, setShowEdit] = React.useState(false);
	const [showNotice, setShowNotice] = React.useState(false);
	const [modeType, setModeType] = React.useState(test?.isRealTime ? 'Strict' : "Open");
	const dispatch = useDispatch()

const handleCreate = async ()=>{
	try{
		if (isInfo) {
			if (name !== '' && description !== '' && level !== '' && lang !== '' && specialty !== '' && field !== '') {
				setIsInfo(false)
				setIsPart(true)
				setIsNext(true)
			} else {
				setMessage("please, fill all the form")
				setOpen(true)
			}
		} else if(isPart) {
			setIsPart(false)
			setIsSend(true)
			setIsNext(true)
		}else{
			if (questions !== null && describe !== "" && response_type !== null && duration !== null && start_date !== null && start_moment !== null) {
				
				const get_mom = handleDiff().start_mom
				const end_mom = handleDiff().end_mom
				const get_dur = handleDiff().diff

			const data = {
				id:test?.id,
				name:name,
				email:user?.email,
				description:description,
				describe:describe,
				specialty:specialty,
				language:lang,
				field:field,
				questions:parseInt(questions),
				level:level,
				isRealTime:modeType === "Strict" ? true : false,
				testQuestions:testQuestions || [],
				start_date:start_date,
				start_moment:get_mom,
				end_moment:end_mom,
				time:parseInt(get_dur),
				response_type:response_type,
				users:[...participants],
				reports:[...test?.reports]
			}

                edit_test(user?.accessToken,add_test,add_tests,tests,dispatch,setOpen,setMessage,data,setLoading,navigate,addData)

			} else {
				setMessage("please, fill all the form")
				setOpen(true)
			}
		}

	}catch(err){
		console.log(err)
	}
}

const handleGenerate = async ()=>{
try{
	if (name !== '' && description !== '' && level !== '' && lang !== '' && specialty !== '' && field !== '' && questions !== null && describe !== "" && response_type !== null && duration !== null && start_date !== null && start_moment !== null) {

		const get_mom = handleDiff().start_mom
		const end_mom = handleDiff().end_mom
		const get_dur = handleDiff().diff

		const data = {
			name:name,
			email:user?.email,
			description:description,
			describe:describe,
			specialty:specialty,
			language:lang,
			field:field,
			start_date:start_date,
			start_moment:get_mom,
			end_moment:end_mom,
			time:parseInt(get_dur),
			questions:parseInt(questions),
			level:level,
			response_type:response_type
		}

		setTestParams(data)

		generate_test(setOpen,setMessage,data,user?.accessToken,setTestQuestions,setGenerating,setIsGenerated)

	} else {
		setMessage("please, fill all the form")
		setOpen(true)
	}
	}catch(err){
		console.log(err)
		setMessage("error while completing your form...please,fill correctly the form")
		setOpen(true)
	}
}

async function addData (newData){
	const getData = await localStorage.getItem("activities")

	if(getData){
		const parseData = JSON.parse(getData)

		if (parseData.length === 4) {
			const updatedData = [...parseData.slice(1), newData]; 
			dispatch(add_activities(updatedData))
			dispatch(add_activity(newData))
			localStorage.setItem("activities",JSON.stringify(updatedData))
		} else { 
			dispatch(add_activities([newData, ...JSON.parse(getData)]))
			dispatch(add_activity(newData))
			localStorage.setItem("activities",JSON.stringify([newData, ...parseData]))
		}

	}else{
		dispatch(add_activities([newData]))
		localStorage.setItem("activities",JSON.stringify([newData]))
	}
}

const handleAdd = ()=>{
	try{
		if (first_name !== "" && last_name !== "" && email !== "") {
			const data = {
				first_name:first_name,
				last_name:last_name,
				email:email,
				hasTook:false,
				hasFinished:false,
				warning:null,
				isDisqualified:false,
				data:[]
			}
		
		const newData = [...participants,data]
	
		setParticipants(newData)
		setFirst_name("")
		setLast_name("")
		setEmail("")

		} else {
			setMessage("You have to fill all the form to add")
			setOpen(true)
		}

	}catch(err){
		console.log(err)
	}
}

const handleDiff = ()=>{
	const diff = dayjs(duration).diff(start_moment, 'minute');
	const start_mom = dayjs(start_moment).format("HH:mm");
	const end_mom = dayjs(duration).format("HH:mm");
	return {diff,start_mom,end_mom}
}

const handleSnackbarClose = ()=>{
	setOpen(false)
}

	return(
		<Box>
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" color="inherit" href="/dashboard">
						Dashboard
					</Link>
					<Typography sx={{fontSize:12,color:"gray"}}>Edit/Test</Typography>
			</Breadcrumbs>			
			</Header>
			<Container>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={handleSnackbarClose} 
					open={open} 
					autoHideDuration={2000}
				/>
				{
				isGenerated  ? 
					<ContainerBox sx={{backgroundColor:"black",m:{md:1},borderRadius:5,padding:2,width:'100%'}}>
						<Box display="flex" justifyContent="space-between" alignItems="center" flexDirection="row">
							<Typography mt={1}  style={{fontSize:15,fontFamily:"dinofans"}}>
								Assessment Question
							</Typography>
							<Box display="flex" justifyContent="space-evenly" flexDirection="row" width="20%">
								<IconButton onClick={(e)=>{
									setShowEdit(true)
								}}>
									<Edit sx={{color:"#ff0"}} fontSize='small'/>
								</IconButton>
								<IconButton onClick={(e)=>{
									e?.preventDefault()
									setShowNotice(true)
								}}>
									<ArrowBack sx={{color:"#ff0"}} fontSize='small'/>
								</IconButton>
							</Box>
						</Box>
						<QuestionBox sx={{p:1,mb:1}}>
							{
								testQuestions?.map((item,index)=>(
									<Box key={index} sx={{width:"100%"}}>
										<Typography mt={1}  style={{fontSize:13,color:"#ff0",fontFamily:"dinofans"}}>
											{index+1}. Question
										</Typography>
										<Typography sx={{p:1,fontSize:13}}>
											{item?.question}
										</Typography>
										<Typography mt={1}  style={{fontSize:13,color:"#ff0",fontFamily:"dinofans"}}>
											Type
										</Typography>
										<Typography sx={{p:1,fontSize:13}}>
											{item?.type}
										</Typography>
										<Box width="70%" sx={{mt:1}}>
											<Typography sx={{fontFamily:"dinofans",fontSize:14,color:"#ff0"}}>
												Choices
											</Typography>
											<ol>
												{
													item?.choices?.map((itm,index)=>(
														<li style={{color:"#fff",fontSize:12}} key={index}>
															{itm}
														</li>
													))
												}
											</ol>
										</Box>
										<Box width="70%" sx={{mt:1}}>
											<Typography sx={{fontFamily:"dinofans",fontSize:14,color:"#ff0"}}>
												Answers
											</Typography>
											<ol>
												{
													item?.answers?.map((itm,index)=>(
														<li style={{color:"#fff",fontSize:12}} key={index}>
															{itm}
														</li>
													))
												}
											</ol>
										</Box>
										<Divider sx={{mt:1,mb:1}}/>
									</Box>
								))
							}
						</QuestionBox>
						<Button disabled={loading} onClick={handleCreate} color="primary" variant="contained">
							{
								isSend && loading ? <CircularProgress size={20} style={{color:"gold"}}/> : isSend && !loading  ? "CREATE" : "NEXT"
							}
						</Button>
					</ContainerBox>
				:
				<Box m={2} sx={{backgroundColor:"black",borderRadius:5,padding:2,width:'100%'}}>
					<Typography mt={1} mb={1} style={{fontSize:18,fontWeight:400,fontFamily:"dinofans"}}>
						Edit Assessment Detail
					</Typography>
					<Box m={1} display="flex" width="90%" flexDirection="row" justifyContent="space-between" alignItems="center">
						<Typography mt={5} mb={5} ml={5} style={{fontSize:16,fontWeight:400,fontFamily:"dinofans"}}>
							{
								isInfo ? "Assessment Info" : isPart ? "Participant Detail" : "Assessment Config"
							}
						</Typography>
						{
						isPart && (
							<Box  display="flex"flexDirection="row" justifyContent="space-between" alignItems="center">
							<Typography style={{fontSize:15,fontWeight:400}}>
								{participants?.length}
							</Typography>
								<IconButton onClick={(e)=>{
									e?.preventDefault()
									setShowDialog(true)
								}} sx={{borderRadius:2,height:25}}>
									<MenuIcon/>
								</IconButton>								
							</Box>

						)}
						{
						isNext && (
							<IconButton sx={{borderRadius:2,height:25}} onClick={()=>{
								if(isSend){
									setIsSend(false)
									setIsPart(true)
								}else if(isPart){
									setIsPart(false)
									setIsInfo(true)
								}else{
									setIsNext(false)
								}
								
							}}>
								<ArrowIcon />
							</IconButton>
						)}
					</Box>
					{
					isInfo && (
						<GridViewContainer>
							<UserInput
								label="Title *"
								isPass={false}
								input={name}
								setInput={setName}
							>
								<FormatAlignCenter/>
							</UserInput>
							<AutoInput
								data={languages}
								setInput={setLang}
								input={lang}
								label="language"
							/>
							<UserInput
								label="Field *"
								input={field}
								isDes={false}
								isPass={false}
								setInput={setField}
							>
								<FormatAlignCenter/>
							</UserInput>
							<AutoInput
								data={levels}
								setInput={setLevel}
								input={level}
								label="level"
							/>
							<UserInput
								label="specialty *"
								input={specialty}
								isPass={false}
								isDes={false}
								setInput={setSpecialty}
							>
								<FormatAlignCenter/>
							</UserInput>
							<Box width="100%">
								<EditorText 
									title="Assessment description"
									data={description}
									setData={setDescription}
									width="95%"
									label="description"
									isRequired={true}
								/>
							</Box>
						</GridViewContainer>
						)
					}
					{
					isSend && (
						<GridViewContainer>
							<UserInput
								label="Start Date *"
								isDate={true}
								input={start_date}
								isPass={false}
								setInput={setStart_date}
							>
								<AccountCircle/>
							</UserInput>
							<TimeInput
								label="start Moment"
								input={start_moment}
								setInput={setStart_moment}
							/>
							<TimeInput
								label="End Moment *"
								input={duration}
								setInput={setDuration}
							/>
							<AutoInput
								data={response_types}
								setInput={setResponse_type}
								input={response_type}
								label="response type"
							/>
							<UserInput
								label="Questions *"
								isPass={false}
								input={questions}
								setInput={setQuestions}
							>
								<AccountCircle/>
							</UserInput>
							{/* <AutoInput
								data={modeArray}
								setInput={setModeType}
								input={modeType}
								label="Mode"
							/> */}
							<Box width="100%">
								<EditorText 
									title="Question description"
									data={describe}
									setData={setDescribe}
									width="95%"
									label="description"
									isRequired={true}
								/>
							</Box>
						</GridViewContainer>
					)}
					{
					isPart && (
						<GridViewContainer>
							<UserInput
								label="Participant first name"
								isPass={false}
								input={first_name}
								setInput={setFirst_name}
							>
								<AccountCircle/>
							</UserInput>
							<UserInput
								label="Participant last name"
								input={last_name}
								isPass={false}
								setInput={setLast_name}
							>
								<AccountCircle/>
							</UserInput>
							<UserInput
								label="Participant email"
								input={email}
								isPass={false}
								setInput={setEmail}
							>
								<AccountCircle/>
							</UserInput>
							<Button sx={{background:"gold",color:"black",marginTop:2,marginLeft:{sm:3,md:0},height:{xs:30,md:35}}} onClick={handleAdd} color="primary" variant="contained">
								Add
							</Button>
						</GridViewContainer>
						)}
						<Box mt={2}>
							{
								(modeType === "Open" && !isGenerated && isSend)? 
									<Button disabled={generating} onClick={handleGenerate} variant="contained">
										{
											generating ? <CircularProgress size={20} style={{color:"gold"}}/> :  "GENERATE"
										}
									</Button>
								:
									<Button disabled={loading} onClick={handleCreate} color="primary" variant="contained">
										{
											isSend && loading ? <CircularProgress size={20} style={{color:"gold"}}/> : isSend && !loading  ? "EDIT" : "NEXT"
										}
									</Button>
							}
						</Box>
				</Box>
				}
				<CustomDialog massDisabled={true} handleUserDelete={(email)=>{
					setParticipants(participants?.filter(item=>item?.email !== email))
				}} data={participants} visible={showDialog} setVisible={setShowDialog}/>
				<EditTestDialog test={testParams} setNewData={setTestQuestions} data={testQuestions} visible={showEdit} setVisible={setShowEdit}/>
				<NoticeDialog visible={showNotice} setVisible={setShowNotice} handleClick={()=>{
						setIsGenerated(false)
						setIsSend(false)
						setIsInfo(true)
						setShowNotice(false)
					}}>
					<ItemView title="Review" content="if you go back, you can not return to view these questions !"/>
				</NoticeDialog>
			</Container>
		</Box>
		)
}

export default EditTest